<section class="content-header mx-2 px-sm-0" tabindex="-1" id="content-header">
    @if (title) {
        <h1>{{ title }}</h1>
    }
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a class="active" aria-current="page" [routerLink]="['/']">
                <fa-icon class="mr-1" icon="home"></fa-icon>
                <span translate>Home</span>
                <fa-icon class="ml-2" icon="chevron-right"></fa-icon>
            </a>
        </li>
        @for (item of breadcrumb; track item) {
            <li class="breadcrumb-item">
                @if (item.route) {
                    <a class="active" aria-current="page" [href]="item.route">
                        <fa-icon class="mr-1" [icon]="item.icon"></fa-icon>
                        <span>{{ item.title | async }}</span>
                        <fa-icon class="ml-2" icon="chevron-right"></fa-icon>
                    </a>
                }
                @if (!item.route) {
                    <span class="active" aria-current="page">
                        <fa-icon class="mr-1" [icon]="item.icon"></fa-icon>
                        <span>{{ item.title | async }}</span>
                    </span>
                }
            </li>
        }
    </ol>
</section>
